import { render, staticRenderFns } from "./sendLink.vue?vue&type=template&id=746b0095&scoped=true&"
import script from "./sendLink.vue?vue&type=script&lang=js&"
export * from "./sendLink.vue?vue&type=script&lang=js&"
import style0 from "./sendLink.vue?vue&type=style&index=0&id=746b0095&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746b0095",
  null
  
)

export default component.exports